export default __webpack_public_path__ + "static/media/danji_big.73704d5a.jpg";